module.exports = __webpack_public_path__ + "img/广州仓库.898e46b5.jpg";